var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"loading":_vm.isLoggedIn},on:{"click":_vm.login}},[_vm._v("Login")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }